<div class="fs-2 with-close" mat-dialog-title>
    {{ isPublished ? 'Ma publication sur LyBox' : 'Publier sur LyBox' }}
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p>
        Votre bien sera visible par tous les utilisateurs du moteur de recherche LyBox,
        avec la mention <b>Annonce partenaire</b> et ses chiffres vérifiés et calculés.
    </p>

    <mat-form-field>
        <mat-label>Lien de l'annonce ou fiche commercial (facultatif)</mat-label>
        <input matInput type="url" [(ngModel)]="url" placeholder="https://">
    </mat-form-field>

    <p class="mb-2">
        Un bien <b>off-market</b> est davantage mis en avant sur LyBox que les biens qui ne le sont pas.
    </p>
    <mat-checkbox [(ngModel)]="offMarket" (ngModelChange)="error = ''" [disabled]="offMarketLocked">Ce bien est off-market</mat-checkbox>
    <p class="text-grey fs-small mb-0" *ngIf="offMarketLocked">Ce bien est déjà diffusé sur un portail, il ne peut pas être déclaré off-market.</p>

    <ng-container *ngIf="offMarket">
        <mat-form-field class="mt-3">
            <mat-label>Je m'engage à ce qu'il reste off-market jusqu'au</mat-label>
            <input matInput [matDatepicker]="picker" [min]="minDateObj" [(ngModel)]="offMarketEndDateObj"
                   (ngModelChange)="error = ''" placeholder="JJ/MM/AAAA">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <p class="publish-warning">
            <i class="fa cfa cfa-warning me-2"></i>
            En cas de signalements trop nombreux sur un bien déclaré off-market qui ne l'est pas,
            LyBox se réserve la possibilité de vous retirer la possibilité de taguer vos biens en off-market.
        </p>
    </ng-container>

    <p class="text-danger mt-2 mb-0" *ngIf="error">{{ error }}</p>
</div>
<div mat-dialog-actions>
    <button *ngIf="!isPublished" (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button *ngIf="isPublished" (click)="unpublish()" type="button" class="btn btn-outline-danger">
        Dépublier
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">{{ isPublished ? 'Enregistrer' : 'Publier' }}</ng-container>
    </button>
</div>
